import actionTypes from '../../constants/actions/importarLineasPedidosExcel/importarLineasPedidosExcel'

export function submitImportarLineasPedidosExcel (value) {
  return {
    type: actionTypes.SUBMIT_IMPORTAR_LINEAS_PEDIDOS_EXCEL,
    value
  }
}

export function submitImportarLineasPedidosExcelSuccess (listImportarLineasPedidosExcel) {
  return {
    type: actionTypes.SUBMIT_IMPORTAR_LINEAS_PEDIDOS_EXCEL_SUCCESS,
    listImportarLineasPedidosExcel
  }
}

export function abrirModalImportarLineasPedidosExcel () {
  return {
    type: actionTypes.ABRIR_MODAL_IMPORTAR_LINEAS_PEDIDOS_EXCEL
  }
}

export function cerrarModalImportarLineasPedidosExcel () {
  return {
    type: actionTypes.CERRAR_MODAL_IMPORTAR_LINEAS_PEDIDOS_EXCEL
  }
}

export function subirArchivosImportarLineasPedidosExcel (archivoExcel) {
  return {
    type: actionTypes.SUBIR_ARCHIVOS_IMPORTAR_LINEAS_PEDIDOS_EXCEL,
    archivoExcel
  }
}

export function descargarPlantillaExcelLineasPedidosExcel () {
  return {
    type: actionTypes.DESCARGAR_PLANTILLA_EXCEL_LINEAS_PEDIDOS_EXCEL
  }
}

export default {
  submitImportarLineasPedidosExcel,
  abrirModalImportarLineasPedidosExcel,
  cerrarModalImportarLineasPedidosExcel,
  subirArchivosImportarLineasPedidosExcel,
  submitImportarLineasPedidosExcelSuccess,
  descargarPlantillaExcelLineasPedidosExcel
}